import { t } from '../strings/i18n';
const allFieldRequiredInstruction = 'label.allFieldRequiredInstruction';
const getAutopayIntroHeading = (isSelectAutopayPaymentMethodMessage, isRevolvingCreditProduct, isEnrolledInCAP) => {
    if (isSelectAutopayPaymentMethodMessage ||
        (isRevolvingCreditProduct && isEnrolledInCAP)) {
        return `${t('autopay.selectAutopayPaymentMethod')} ${t(allFieldRequiredInstruction)}`;
    }
    return `${t('autopay.selectAutopayAmountAndPaymentMethod')} ${t(allFieldRequiredInstruction)}`;
};
export default getAutopayIntroHeading;
